var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"FilePicker"},[_c('PhiFilesystemFolder',{attrs:{"url":_vm.url,"api":_vm.api},on:{"select":_vm.onSelect}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }